<template>
  <v-dialog :value="value" @input="$emit('input', $event)" width="600" persistent no-click-animation>
    <v-card>
      <v-toolbar color="transparent" flat height="60">
        <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Seleccionar un cliente</v-toolbar-title>
        <v-spacer />
        <v-toolbar-items>
          <v-row align="center" justify="center" class="pr-1">
            <v-btn icon retain-focus-on-click :ripple="false" small @click="close"><v-icon small>mdi-close</v-icon></v-btn>
          </v-row>
        </v-toolbar-items>
      </v-toolbar>
      <v-divider />
      <v-card-text class="pa-0 background">
        <v-row align="center" justify="center" no-gutters>
          <v-col cols="12" class="text-left">
            <v-col class="py-2">
              <v-text-field v-model="query" background-color="white" outlined single-line dense placeholder="Escribe para buscar un cliente..." hide-details />
            </v-col>
            <v-divider />
            <v-skeleton-loader v-if="$store.state.customers.retrieveLoader" type="list-item" />
            <template v-else>
              <template v-if="customersList.length">
                <v-simple-table>
                  <template v-slot:default>
                    <tbody>
                      <tr v-for="c in customersList" :key="c.id" @click="select(c)" style="cursor: pointer">
                        <td>
                          <span class="body-1 text--secondary font-weight-medium">{{c.name}}</span>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </template>
              <v-col v-else class="text-center py-5">
                <v-icon color="secondary" size="70">mdi-close-circle</v-icon>
                <span class="d-block subtitle-1">No existen clientes</span>
              </v-col>
            </template>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapState } from 'vuex'
import GenericViewMixin from '@/mixins/GenericViewMixin'

export default {
  mixins: [
    GenericViewMixin
  ],
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    query: ''
  }),
  computed: {
    ...mapState({
      customersList: state => state.customers.customersList
    })
  },
  watch: {
    query () {
      this.debounceMethod(this.load)
    },
    value (open) {
      if (open) {
        this.query = ''
        this.load()
      }
    }
  },
  methods: {
    close () {
      this.$emit('input', false)
    },
    load () {
      if ([1, 2].includes(this.query.length)) return
      const params = { page_size: 10 }
      if (this.query.length >= 3) {
        params.name__icontains = this.query.toLowerCase()
      }
      this.$store.dispatch('customers/LIST', {
        resource: 'customers',
        query: params
      })
    },
    select (customer) {
      this.$emit('select', customer)
      this.close()
    }
  }
}
</script>
